export class GroupTranslation {
    public groupName: string;
    public translation: string;
}